import script from "./menuForm.vue?vue&type=script&setup=true&lang=js"
export * from "./menuForm.vue?vue&type=script&setup=true&lang=js"

import "./menuForm.vue?vue&type=style&index=0&id=b94fe6d4&lang=css"
import "./menuForm.vue?vue&type=style&index=1&id=b94fe6d4&scoped=true&lang=css"
import "./menuForm.vue?vue&type=style&index=2&id=b94fe6d4&lang=css"
import "./menuForm.vue?vue&type=style&index=3&id=b94fe6d4&lang=css"
import "./menuForm.vue?vue&type=style&index=4&id=b94fe6d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b94fe6d4"]])

export default __exports__